/**
 * 当前选中店铺的作用域，存本地，所有请求通过 store-id 头上送
 */
const STORE_ID_KEY = 'store-id';

export function getStoreId(): string {
  return localStorage.getItem(STORE_ID_KEY) || '';
}

export function setStoreId(storeId: number | string) {
  localStorage.setItem(STORE_ID_KEY, String(storeId));
}

export function clearStoreId() {
  localStorage.removeItem(STORE_ID_KEY);
}
